import { getCountryCallingCode } from "../../../libphonenumber-js/es6/metadata.js";
function getInternationalPhoneNumberPrefix(country, metadata) {
  var prefix = "+" + getCountryCallingCode(country, metadata);
  return prefix;
}
export {
  getInternationalPhoneNumberPrefix as default
};
//# sourceMappingURL=getInternationalPhoneNumberPrefix.js.map
